module.exports = __webpack_public_path__ + "img/kaist_gallery7.a706dc37.jpg";